import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { StatusBar } from "../../../ui/StatusBar/StatusBar";
import {
  FiltersSidebar,
  useFiltersState,
} from "../../FiltersSidebar/FiltersSidebar";
import { WheelsFilters } from "../Filters/WheelsFilters";

type WheelStatusbarProps = {
  className?: string;
  isLoading: boolean;
};

export const WheelStatusbar: FunctionComponent<WheelStatusbarProps> = ({
  className,
  isLoading,
}) => {
  const [, { hide }] = useFiltersState();
  return (
    <StatusBar className={clsx("mb-1", className)} isLoading={isLoading}>
      {null}
      <FiltersSidebar>
        <WheelsFilters onClose={hide} />
      </FiltersSidebar>
    </StatusBar>
  );
};
